import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteTierMutation = createMutationHook(MembershipsCreatorApiClient.deleteTier, {
  mutationKey: ['deleteTier'],
})
